import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const MLP_ACTION_TYPES = {
	GET_MLPS_SUCCESS: 'GET_MLPS_SUCCESS',
    POST_MLP_SUCCESS: 'POST_MLP_SUCCESS',
    PUT_MLP_SUCCESS: 'PUT_MLP_SUCCESS',
    DELETE_ARTICLE_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_MLPS_PAGINATION: 'UPDATE_MLPS_PAGINATION',
    GET_MLP_VALUES_SUCCESS: 'GET_MLP_VALUES_SUCCESS'
};

const MLPS_URL = `${ENTRYPOINT}${API_ROUTES.MLPS}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (filters = {}) => {
    const { startDate, endDate, customer } = filters;
    let filterParams = '';

    if (startDate) {
        filterParams = `${filterParams}&date[after]=${startDate.format('L')}`;
    }
    if (endDate) {
        filterParams = `${filterParams}&date[before]=${endDate.format('L')}`;
    }
    if (customer) {
        const { uuid: customer_uuid } = customer;
        filterParams = `${filterParams}&customer=${customer_uuid}`;
    }
    return filterParams;
}

export const getMlps = (data = { page: 0, rowsPerPage: 10, filters: { }}) => {
    return async (dispatch) => {
        let paginationParams = getPaginationParams(data);
        const { filters } = data;
        let filterParams = getFilterParams(filters);
        const GET_MLPS_URL = `${ENTRYPOINT}${API_ROUTES.MLP_LIST}${paginationParams}${filterParams}`;
        const response = await getData(GET_MLPS_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: MLP_ACTION_TYPES.GET_MLPS_SUCCESS, payload: response['hydra:member'] });
        const MLP_VALUES_URL = `${ENTRYPOINT}${API_ROUTES.MLP_VALUES}${paginationParams}${filterParams}`;
        const values = await getData(MLP_VALUES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: MLP_ACTION_TYPES.GET_MLP_VALUES_SUCCESS, payload: values });
        dispatch({ type: MLP_ACTION_TYPES.UPDATE_MLPS_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getMlp = async (uuid) => {
    const GET_MLP_URL = `${MLPS_URL}/${uuid}`;
    return await getData(GET_MLP_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
}

export const postMlp = (data) => {
    return async (dispatch) => {
        const response = await postData(MLPS_URL, data);
        dispatch({ type: MLP_ACTION_TYPES.POST_MLP_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.MLPS);
    }
}

export const putMlp = (uuid, data) => {
    return async (dispatch) => {
        const PUT_MLP_URL = `${MLPS_URL}/${uuid}`;
        const response = await putData(PUT_MLP_URL, data);
        dispatch({ type: MLP_ACTION_TYPES.PUT_MLP_SUCCESS, payload: response });
        history.push(REACT_ROUTES.MLPS);
    }
}

export const deleteMlp = (uuid) => (
    async () => {
        const DELETE_MLP_URL = `${MLPS_URL}/${uuid}`;
        await deleteData(DELETE_MLP_URL);
    }
)

export const updateMlpsPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: MLP_ACTION_TYPES.UPDATE_MLPS_PAGINATION, payload: { rowsPerPage, page, filters } });
    }
}

export function printMlpList(filters) {
    return async () => await getData(`${ENTRYPOINT}${API_ROUTES.MLP_LIST_PRINT}?${getFilterParams(filters)}`);
}

